import { hash } from '@ember/helper';
import { service } from '@ember/service';

import { t } from 'ember-intl';
import { trackedFunction } from 'reactiveweb/function';

import Component from 'umg-ember-backend/components/record-detail/forms';
import Form from 'umg-ember-backend/components/ui/form';
import InfoBox from 'umg-ember-backend/components/ui/info-box';

export default class RecordDetailFormsMlpNewsFeedComponent extends Component {
  // Services
  @service data;

  // Getter and setter
  get articleTypes() {
    return this.resolvedArticleTypes.value ?? [];
  }

  // Functions
  resolvedArticleTypes = trackedFunction(this, async () => {
    return await this.data.getCategories({ 'filter[type]': 'A_TYPE' });
  });

  // Template
  <template>
    {{#if @mlp.isV2}}
      <Form @model={{@model}} @showErrors={{@showErrors}} as |form|>
        <div class='o-layout'>
          <div class='o-layout__item u-1/1'>
            <form.fieldset @titleKey='elements' as |fieldset|>
              <fieldset.field @property='headline' />
              <fieldset.field
                @property='artist'
                @type='belongs-to'
                @on={{hash openNewRecord=false}}
              />
              <fieldset.field
                @property='channel'
                @type='belongs-to'
                @on={{hash openNewRecord=false}}
              />

              <fieldset.field
                @property='articleType'
                @type='select-record'
                @options={{this.articleTypes}}
              />

              <fieldset.field @property='limit' @type='number' />

              <fieldset.field
                @property='taxa'
                @type='has-many'
                @on={{hash openNewRecord=false}}
              />
            </form.fieldset>
          </div>
        </div>
      </Form>
    {{else}}
      <InfoBox @type='warning'>
        {{t 'record_detail.forms.mlp_news_feed.only_for_mlp_v2'}}
      </InfoBox>
    {{/if}}
  </template>
}
